<template>
  <router-view />
</template>
<script>
import { inject } from 'vue'
export default {
  data() {
    return {
      globalVars: ''
    }
  },
  mounted() {
    //全局变量注入，监听页面尺寸变化
    this.globalVars = inject('globalVars')
    this.globalVars.innerHeight = window.innerHeight
    console.log(this.globalVars.innerHeight)
    window.onresize = () => (() => {
      this.changeWindowSize()
    })();
  },
  methods: {
    changeWindowSize() {
      this.globalVars.innerHeight = window.innerHeight
    }
  }
}
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  /* filter: grayscale(1) */
}

* {
  margin: 0;
  padding: 0;
  border: 0;
  scroll-behavior: smooth; //平滑滚动
}
@media screen and (max-width: 768px) {
  #app {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding: 20px;
  }

  #app > * {
    display: none !important; // 隐藏所有内容
  }

  #app::before {
    content: "手机访问请使用 App或者小程序";
    display: block;
    margin-top: 50px;
  }
}

</style>
